module.exports = __webpack_public_path__ + "img/12.7ba3cf86.jpg";